module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "yearSelector selector x-column x-sm mtn x-1-3"
  }, [_vm._m(0), _vm._v(" "), _c('ul', _vm._l((_vm.modes), function(mode) {
    return _c('li', [_c('label', {
      staticClass: "checkbox-wrapper",
      attrs: {
        "for": mode
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedMode),
        expression: "selectedMode"
      }],
      staticClass: "input-checkbox",
      attrs: {
        "name": "modes[]",
        "type": "radio",
        "id": mode
      },
      domProps: {
        "value": mode,
        "checked": _vm._q(_vm.selectedMode, mode)
      },
      on: {
        "__c": function($event) {
          _vm.selectedMode = mode
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "checkbox"
    }), _vm._v(" "), _c('span', {
      staticClass: "checkbox-label"
    }, [_vm._v(_vm._s(mode))])])])
  }))]), _vm._v(" "), (_vm.selectedMode == 'competition') ? _c('div', {
    staticClass: "competitionSelector selector x-column x-sm mtn x-1-3"
  }, [_vm._m(1), _vm._v(" "), _c('ul', _vm._l((_vm.competitions), function(competition) {
    return _c('li', [_c('label', {
      staticClass: "checkbox-wrapper",
      attrs: {
        "for": competition.slug
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected.competitions),
        expression: "selected.competitions"
      }],
      staticClass: "input-checkbox",
      attrs: {
        "name": "competitions",
        "type": "radio",
        "id": competition.slug
      },
      domProps: {
        "value": competition.slug,
        "checked": _vm._q(_vm.selected.competitions, competition.slug)
      },
      on: {
        "__c": function($event) {
          _vm.selected.competitions = competition.slug
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "checkbox"
    }), _vm._v(" "), _c('span', {
      staticClass: "checkbox-label"
    }, [_vm._v(_vm._s(competition.name))])])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.selectedMode == 'competition' && !!_vm.selected.competitions.length) ? _c('div', {
    staticClass: "yearSelector selector x-column x-sm mtn x-1-3"
  }, [_vm._m(2), _vm._v(" "), _c('ul', _vm._l((_vm.years), function(year) {
    return _c('li', [_c('label', {
      staticClass: "checkbox-wrapper",
      attrs: {
        "for": year.slug
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected.years),
        expression: "selected.years"
      }],
      staticClass: "input-checkbox",
      attrs: {
        "name": "years[]",
        "type": "checkbox",
        "id": year.slug
      },
      domProps: {
        "value": year.slug,
        "checked": Array.isArray(_vm.selected.years) ? _vm._i(_vm.selected.years, year.slug) > -1 : (_vm.selected.years)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selected.years,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = year.slug,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.selected.years = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selected.years = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selected.years = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "checkbox"
    }), _vm._v(" "), _c('span', {
      staticClass: "checkbox-label"
    }, [_vm._v(_vm._s(year.name) + " (" + _vm._s(year.questionsByYear) + ")")])])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.selectedMode == 'topics') ? _c('div', {
    staticClass: "topicSelector selector x-column x-sm mtn x-1-3"
  }, [_vm._m(3), _vm._v(" "), _c('ul', _vm._l((_vm.topics), function(topic) {
    return _c('li', [_c('label', {
      staticClass: "checkbox-wrapper",
      attrs: {
        "for": topic.slug
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected.topics),
        expression: "selected.topics"
      }],
      staticClass: "input-checkbox",
      attrs: {
        "name": "topics[]",
        "type": "checkbox",
        "id": topic.slug
      },
      domProps: {
        "value": topic.slug,
        "checked": Array.isArray(_vm.selected.topics) ? _vm._i(_vm.selected.topics, topic.slug) > -1 : (_vm.selected.topics)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selected.topics,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = topic.slug,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.selected.topics = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selected.topics = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selected.topics = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "checkbox"
    }), _vm._v(" "), _c('span', {
      staticClass: "checkbox-label"
    }, [_vm._v(_vm._s(topic.name))])])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.selectedMode == 'keywords') ? _c('div', {
    staticClass: "keywordSelector selector x-column x-sm mtn x-1-3"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    attrs: {
      "type": "text",
      "name": "keyword"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.keywordCount) ? _c('div', [_vm._v("\n      found " + _vm._s(_vm.keywordCount) + " questions\n    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.start()
      }
    }
  }, [_vm._v("START")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "mtn h4"
  }, [_c('span', [_vm._v("Tests By")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "mtn h4"
  }, [_c('span', [_vm._v("Select Competition")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "mtn h4"
  }, [_c('span', [_vm._v("Select Years")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "mtn h4"
  }, [_c('span', [_vm._v("Select Topic")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "mtn h4"
  }, [_c('span', [_vm._v("Select Keyword")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61e8b5a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Settings.vue
// module id = 48
// module chunks = 0